import { UserSelectionWidget, ShopSelectionWidget } from 'components/FormWidget';

const uiSchema = () => ({
  'ui:order': ['title', 'user_id', 'shop_id', 'fee_type_id', 'fee_value', 'fee_ceiling', '*'],
  shop_id: {
    'ui:widget': ShopSelectionWidget,
  },
  user_id: {
    'ui:widget': UserSelectionWidget,
  },
});

export default uiSchema;
